module.exports = __webpack_public_path__ + "img/instrame.1488c08f.png";